import PropTypes from 'prop-types';
import { FileIcon } from 'assets/icons';

import styles from './styles.module.scss';

function DocDownloadBtn({ text, handleBtnClick, disabled }) {
  const handleClick = () => {
    if (disabled) return;

    handleBtnClick();
  };

  return (
    <div
      className={`${styles.button} ${disabled ? styles.disabled : ''}`}
      onClick={handleClick}
    >
      <img src={FileIcon} alt='' />
      {text && <span className={styles.button__text}>{text}</span>}
    </div>
  );
}

DocDownloadBtn.defaultProps = {
  handleBtnClick: () => {},
  disabled: false,
};

DocDownloadBtn.propTypes = {
  text: PropTypes.string,
  handleBtnClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DocDownloadBtn;
